import { UUID_REGEX } from './constants';

export function isUUID(str: string): boolean {
  return new RegExp(UUID_REGEX).test(str);
}
